<template lang="pug">
  .add-yezza-store-page
    v-app-bar.white.elavation-0(app light style="box-shadow: 0 2px 4px 0 rgba(0,0,0,.08) !important;")
      v-container(style="max-width:600px")
        v-layout.my-2
          div.mr-2
            v-icon.mt-1(left color="black" :size="24" @click="$router.go(-1)") mdi-arrow-left
          div.title.font-weight-bold {{ 'Store Page' }}
          v-spacer
          v-btn.mr-2.my-auto(color='accent' filled depressed height=28 :loading="isLoading" @click="clickSave" small)
            div(v-if="page") {{ $t('save') }}
            div(v-else) {{ $t('create') }}

    v-container(style="max-width:600px")
      v-card
        v-card-text.pa-0
          v-form.pa-4(ref="form")
            template(v-if="member.role !== 'Agent' && member.role !== 'Salesperson'")
              .form-name
                v-text-field.mt-2(v-model='pageTitle' :label="$t('form_name.label')" :placeholder="$t('form_name.placeholder')" outlined dense :rules="rules.not_empty" counter :maxlength="100" @blur="updateSlug")

              .form-slug
                v-text-field.mb-4(v-model='pageSlug' :label="$t('form_slug.label')" :placeholder="$t('form_slug.placeholder')" outlined dense :rules="rules.slug" counter :maxlength="100")

              p.title.mb-0 Choose WhatsApp Form
              v-select(ref="layoutSelect" v-model="pageForm" item-text="name" return-object :items="forms" outlined dense :rules="rules.has_quantity" :loading="isFetchingForms")
                template(v-slot:item="{ index, item }")
                  v-layout
                    v-col.px-0.text-left
                      div {{ item.name }}
                      div.grey--text.body-2.text--darken-1.mb-0
                        span.mr-2 Products: {{ item.products.length }}
                        span.mr-2 Clicks: {{ item.total_clicks }}
                        span.mr-2 Sales: {{ item.total_sales | displayPrice }}
              p.title.mb-0 Edit Page Content
              froala.my-12(id="edit" :tag="'textarea'" :config="config" v-model="pageHtml")

</template>

<script>
import { mapActions, mapState } from 'vuex'
 import Vue from 'vue'
// //Import Froala Editor
 import 'froala-editor/js/plugins.pkgd.min.js';
// //Import third party plugins
 import 'froala-editor/js/third_party/font_awesome.min';
 //import CodeMirror from "codemirror";
 //import "codemirror/mode/xml/xml";
 //import "codemirror/lib/codemirror.css";
// // Import Froala Editor css files.
 import 'froala-editor/css/froala_editor.pkgd.min.css';
 import FroalaEditor from 'froala-editor/js/froala_editor.min'
// // Import and use Vue Froala lib.
 import VueFroala from 'vue-froala-wysiwyg'
 Vue.use(VueFroala)
 FroalaEditor.DefineIcon('textColor', {SRC: 'https://nocode.hanifrodili.com/img/font-color.3cd513fe.svg', ALT: 'textcolor', template: 'image'});
 FroalaEditor.DefineIcon('backgroundColor', {SRC: 'https://nocode.hanifrodili.com/img/font-bg.dc3f7829.svg', ALT: 'text background color', template: 'image'});
 FroalaEditor.DefineIcon('paragraphFormat',{SVG_KEY: 'fontSize'}) 
  FroalaEditor.RegisterCommand('imageButton', {
    title: 'Image',
    icon: 'imageIcon'
  });
 
export default {
  name: 'AddYezzaStorePage',
  props: ['open', 'company', 'page'],
  data: vm => ({
    pageTitle: '',
    pageSlug: '',
    pageForm: null,
    forms: [],
    isFetchingForms: false,
    isLoading: false,
    config: {
      events: {
        'image.beforeUpload' (files) {
          var editor = this
          if (!files.length) { return }
          let file = files[0]
          let fileReader = new FileReader()
          fileReader.onload = e => {
            let image = new Image()
            image.onload = () => {
              let canvas = document.createElement('canvas')
              let maxSize = 960
              let width = image.width
              let height = image.height
              let resizeFactor = 1.0
              if (width > maxSize || height > maxSize) {
                if (height > width) {
                  resizeFactor = maxSize / height
                } else {
                  resizeFactor = maxSize / width
                }
              }
              let resizeWidth = width * resizeFactor
              let resizeHeight = height * resizeFactor
              canvas.width = resizeWidth
              canvas.height = resizeHeight
              canvas.getContext('2d').drawImage(image, 0, 0, resizeWidth, resizeHeight)
              canvas.toBlob((blob) => {
                const resizeImageFile = new File([blob], 'product_image.jpeg', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                })
                var params = new FormData()
                params.append('file', resizeImageFile)
                vm.$axios.post(`/documents/`, params)
                  .then(resp => {
                    console.log(resp.data)
                    editor.image.insert(resp.data.file, false, null, editor.image.get())
                  })
                  .catch(() => {
                    this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
                  })
              }, 'image/jpeg', 1)
            }
            image.src = e.target.result
          }
          fileReader.readAsDataURL(file)
          return false
        }
      },
      key: process.env.VUE_APP_FROALA_API_KEY,
      attribution: false,
      codeBeautifierOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      // codeMirror: CodeMirror,
      
      toolbarStickyOffset: vm.$vuetify.breakpoint.xs ? 56 : 64,
      toolbarButtons: 	{
        'moreText': {
          'buttons': [ 'undo','paragraphFormat', 'textColor','backgroundColor', 'insertImage' ],
         'buttonsVisible': 5
         },
        'moreMisc': {
          'buttons': ['insertVideo', 'emoticons','bold', 'italic', 'underline', 'strikeThrough','lineHeight','alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL','redo', 'fullscreen', 'html'],
          'buttonsVisible': 0
          }
      },
      quickInsertEnabled: false,
      toolbarSticky: false,
      imageDefaultMargin: 10,
      imageDefaultWidth: '80%',
      //imageDefaultSize: '80%',
      imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
      imageEditButtons: ['imageCaption', 'imageRemove','linkOpen'],
      videoInsertButtons: ['videoBack', '|', 'videoByURL'],
      fontSize: ['10', '12', '14', '18', '30', '60', '96'],
      videoEditButtons: ['videoReplace', 'videoRemove'],
      colorsText : ['#333333','#848484','#A66049','#E06E38','#DBAA00','#008364', '#2C81E4','#6F62FF','#DC3B75','#CD3300'],
      colorsBackground : ['#FFFFFF','#EFEFEF','#F0E5E2','#FAE4DA','#F7ECC7','#E6F3F0','#E1EDFB', '#EDECFF','#FBE6ED','#F8DBD9'],
      //colorsBackground : ['#FFFFFF','#33333314','#A6604929','#E06E3830','#DBAA0038','#0083641A','#2C81E424', '#6F62FF1F','#DC3B7521','#CD0C0026'],
      paragraphFormat: {
      N: 'Normal',
      H1: 'Headline',
      H3: 'Subheadline',
      H4: 'Title'
      },
      lineHeights: {
        'Zero' : '0',
        '0.5' : '0.5',
        'Single': '1',
        '1.5': '1.5',
        Double: '2'
      }
    },
    pageHtml: '',
    rules: {
      not_empty: [v => (v || '').length > 0 || 'This field is required'],
      slug: [
        v => (v || '').length > 0 || `This field is required`,
        v => /^[a-zA-Z0-9-]*?$/.test(v) || 'Slug must be valid',
        v => v.charAt(v.length - 1) != '-' || `Must not end with '-' sign`,
      ],
      has_quantity: [(v) => !!v || 'Form is required', (v) => v != 0|| 'Form is required']
    }
  }),
  computed: {
    ...mapState('user', ['member']),
    currentPage: {
      get() {
        return this.page
      },
      set(newValue) {
        this.$emit('update:page', newValue)
      }
    }
  },
  mounted () {
    this.fetchForms()
    if (this.page) {
      this.pageTitle = this.page.title
      this.pageSlug = this.page.slug
      this.pageHtml = this.page.content
      // this.pageHtml = this.page.content_html
      this.pageForm = this.page.form
    }
  },
  watch: {
    pageSlug (val) {
      this.pageSlug = val.toLowerCase().replace(/[\W_]+/g, ' ').replace(/ /g, '-')
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms() {
      this.isFetchingForms = true
      this.$axios.get(`/forms?page_size=100&company=${this.company.id}&has_product=true`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.forms = resp.data.results
            this.forms.forEach(form => {
              if (form.id == this.pageForm) {
                this.pageForm = form
              }
            })
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingForms = false
        })
    },
    updateSlug () {
      if (this.pageSlug || !this.pageTitle) {
        return
      }
      this.pageSlug = this.pageTitle
    },
    handleDeleteItem (index) {
      this.extraFields.splice(index, 1)
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.pageHtml) {
        this.showMessage(['error', this.$t('error_message.page_content_not_empty')])
        return
      }
      this.isLoading = true
      const params = {
        company : this.company.id,
        title : this.pageTitle,
        slug : this.pageSlug,
        form : this.pageForm.id,
        content: this.pageHtml
        // content: this.pageHtml.split('font-family').join('font')
      }
      if (this.page) {
        this.axios.put(`/store/settings/${this.company.slug}/pages/${this.page.slug}/`, params)
        .then(resp => {
          this.currentPage = resp.data
          this.showMessage(['success', this.$t('success_message.page_updated')])
          this.$router.go(-1)
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.form) {
            this.showMessage(['error', e.response.data.form])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/store/settings/${this.company.slug}/pages/`, params)
        .then(resp => {
          this.$emit('added', resp.data)
          this.showMessage(['success', this.$t('success_message.page_created')])
          this.$router.go(-1)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style>
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}


div.fr-box.fr-basic .fr-wrapper {
  border-left: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.38) !important;
}


div.fr-toolbar.fr-top {
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 5px 5px 0 0 !important;
}

div.second-toolbar {
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 0 0 5px 5px !important
}

.froala-element {
  line-height: 140%;
}

.froala-element ul,
.froala-element ol,
ul.fr-tag,
ol.fr-tag {
  padding-left: 25px;
}

.froala-element p,
p.fr-tag {
  margin: 0 0 17px;
}

.froala-element h1,
h1[class="fr-tag"] {
  font-size: 40px !important;
  line-height: 1.1;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
}

.froala-element h2,
h2[class="fr-tag"] {
  font-size: 30px;
  line-height: 1.1;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
}

.froala-element h3,
h3[class="fr-tag"] {
  font-size: 24px;
  line-height: 1.1;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
}

.froala-element h4,
h4[class="fr-tag"] {
  font-size: 18px;
  line-height: 1.1;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 10px;
}

.froala-element h5,
h5[class="fr-tag"] {
  font-size: 14px;
  line-height: 1.1;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 10px;
}

.froala-element h6,
h6[class="fr-tag"] {
  font-size: 12px;
  line-height: 1.1;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>

<i18n>
{
  "en": {
    "form_name": {
      "label": "Page Name",
      "placeholder": "Write page name here"
    },
    "form_slug": {
      "label": "Page Slug",
      "placeholder": "Write page slug here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "Name",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "Phone",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "Email",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save"
  },
  "ms": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "form_slug": {
      "label": "Form URL",
      "placeholder": "Write custom form URL here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "Nama",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "No Telefon",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "E-mel",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  },
  "zh": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "form_slug": {
      "label": "Form URL",
      "placeholder": "Write custom form URL here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "姓名",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "电话号码",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "电子邮件",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  },
  "ta": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "form_slug": {
      "label": "Form URL",
      "placeholder": "Write custom form URL here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "பெயர்",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "தொலை பேசி இலக்கம்",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "மின் அஞ்சல்",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  }
}
</i18n>
